import { USERS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import usersTypes from '../../constants/usersTypes'
import { axios } from '../../services'
import store from '../../store'

import { update_current_user } from './'
// import { try_force_logoff } from '../auth'


//
const get_user_request = () => {
  return {
    type: usersTypes.get.request
  }
}

const get_user_success = (response) => {
  return {
    type: usersTypes.get.success,
    payload: response.data
  }
}

const get_user_failure = (messages) => {
  return {
    type: usersTypes.get.failure,
    payload: messages
  }
}

const get_user = (user_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(get_user_request())

    // Request
    axios.get(
      formatRoute(USERS_ROUTES.get, {id: user_id})
    ).then( response => {
      // success
      const {id} = store.getState().auth.current_user.data
      if (user_id === id) {
        dispatch( update_current_user(response) )
      }
      dispatch( get_user_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching user."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_user_failure(errors))
    })
  }

}

export {
  get_user
}



// WEBPACK FOOTER //
// ./src/js/actions/users/get.js